import { keyframes } from 'styled-components';

export const FadeInBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30%);
  }
  100% {
    transform: 1;
    transform: translateY(0);
  }
`;
